// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"page_titleBox___xK9D","titleBoxApp":"page_titleBoxApp__4Pwrc"};